export const runtimeSchema = {
  type: 'object',
  required: ['product', 'bundles', 'translations'],
  properties: {
    product: {
      type: 'object',
      required: [
        'id',
        'pwrRated',
        'bcurveScale',
        'bcurveExpo',
        'bcurveSlope',
        'bcurveComp',
        'vah',
        'ptare',
      ],
      properties: {
        id: { type: 'string' },
        name: { type: ['string', 'null'] },
        family: { type: ['string', 'null'] },
        url: { type: ['string', 'null'] },
        startPoint: { type: ['number', 'null'] },
        pwrRated: { type: 'number', exclusiveMinimum: 0 },
        maxPower: { type: 'number', exclusiveMinimum: 0 },
        bcurveScale: { type: 'number', exclusiveMinimum: 0 },
        bcurveExpo: { type: 'number', exclusiveMinimum: 0 },
        bcurveSlope: { type: 'number', exclusiveMinimum: 0 },
        bcurveComp: { type: 'number' },
        vah: { type: 'number', exclusiveMinimum: 0 },
        ptare: { type: 'number', exclusiveMinimum: 0 },
      },
    },
    bundles: {
      type: 'array',
      items: {
        type: 'object',
        required: ['id', 'quantity', 'vah'],
        properties: {
          id: { type: 'string' },
          quantity: { type: 'number' },
          vah: { type: 'number', exclusiveMinimum: 0 },
          url: { type: 'string' },
        },
      },
    },
    translations: {
      type: 'object',
      required: [
        'xAxisLabel',
        'yAxisLabel',
        'tooltipTitle',
        'powerW',
        'powerkW',
        'timeMin',
        'timeSec',
        'timeH',
        'printLabel',
      ],
      properties: {
        xAxisLabel: { type: 'string' },
        yAxisLabel: { type: 'string' },
        tooltipTitle: { type: 'string' },
        info: { type: ['string', 'null'] },
        powerW: { type: 'string' },
        powerkW: { type: 'string' },
        timeMin: { type: 'string' },
        timeSec: { type: 'string' },
        timeH: { type: 'string' },
        printLabel: { type: 'string', default: '' },
      },
    },
  },
};
